/*
 * Silk Romance - Scroll-Based Product Discovery (Next-Phase, section 7)
 * Triggers once per page view after ~45% scroll depth on product pages.
 * Uses Shopify's native /recommendations/products.json endpoint (real
 * catalog relevance signal, not a guess) so recommendations are genuine.
 * Gated through window.SRAttentionManager so it never competes with
 * Exit Intent / Spin & Win / Support Agent invitations - only one
 * interruptive UI is ever active at a time.
 */
(function () {
  'use strict';
  var TRIGGER_RATIO = 0.45;
  var fired = false;

  function scrollRatio() {
    var doc = document.documentElement;
    var scrollTop = window.scrollY || doc.scrollTop;
    var height = doc.scrollHeight - doc.clientHeight;
    if (height <= 0) return 0;
    return scrollTop / height;
  }

  function buildPopup(products) {
    var wrap = document.createElement('div');
    wrap.className = 'sr-scroll-discovery';
    wrap.innerHTML = '<button class="sr-scroll-discovery__close" aria-label="Close">&times;</button>' +
      '<p class="sr-scroll-discovery__heading">Looking for something similar? ✨</p>' +
      '<div class="sr-scroll-discovery__grid">' + products.map(function (p) {
        return '<a class="sr-scroll-discovery__card" href="' + p.url + '" data-sr-sd-handle="' + p.handle + '">' +
          '<img src="' + (p.featured_image || '') + '" alt="" loading="lazy" width="90" height="120">' +
          '<span>' + p.title + '</span></a>';
      }).join('') + '</div>';
    document.body.appendChild(wrap);

    wrap.querySelector('.sr-scroll-discovery__close').addEventListener('click', function () {
      wrap.remove();
      if (window.SRAttentionManager) window.SRAttentionManager.release('scroll_discovery');
    });
    wrap.querySelectorAll('[data-sr-sd-handle]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.SREvents) window.SREvents.track('scroll_recommendation_clicked', { handle: el.getAttribute('data-sr-sd-handle') });
      });
    });

    if (window.SREvents) window.SREvents.track('scroll_recommendation_shown', { count: products.length });
  }

  async function maybeShow(productId) {
    if (fired) return;
    if (window.SRAttentionManager && !window.SRAttentionManager.request('scroll_discovery')) return;
    fired = true;
    try {
      var res = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=related');
      if (!res.ok) { if (window.SRAttentionManager) window.SRAttentionManager.release('scroll_discovery'); return; }
      var data = await res.json();
      var products = (data.products || []).slice(0, 3);
      if (!products.length) { if (window.SRAttentionManager) window.SRAttentionManager.release('scroll_discovery'); return; }
      buildPopup(products);
    } catch (e) {
      if (window.SRAttentionManager) window.SRAttentionManager.release('scroll_discovery');
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pageData = document.getElementById('sr-current-product-data');
    if (!pageData) return; // only run on product pages, matches the spec's PDP scroll-discovery use case
    var current;
    try { current = JSON.parse(pageData.textContent); } catch (e) { return; }
    if (!current || !current.id) return;

    var onScroll = function () {
      if (scrollRatio() >= TRIGGER_RATIO) {
        maybeShow(current.id);
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
